<template>
    <HeaderCell
        v-for="column in columns"
        :key="column.key"
        :column="column"
        :columnWidth="columnsWidth[column.key]"
        :setHeaderWidth="setHeaderWidth"
        :currentSorter="currentSorter"
        :changeCurrentSorter="changeCurrentSorter"
        :isInPageMode="isInPageMode"
        :headerBorder="headerBorder"
    >
        <component :is="slots?.['header-' + column.key]" v-bind="{ ...column }" />
    </HeaderCell>
    <div
        v-if="fixedColumns.left.length"
        :class="['pt-table-header_fixed', 'pt-table-header_fixed-left', { ['reach-border']: scrollInfo.scrollLeft === 0 } ]"
        :style="{ transform: `translate3d(${scrollInfo.scrollLeft}px, 0, 0)`}"
    >
        <HeaderCell
            v-for="column in fixedColumns.left"
            :key="'fixed' + column.key"
            :column="column"
            :columnWidth="columnsWidth[column.key]"
            :setHeaderWidth="setHeaderWidth"
            :currentSorter="currentSorter"
            :changeCurrentSorter="changeCurrentSorter"
            :isFixedHeader="true"
            :isInPageMode="isInPageMode"
            :headerBorder="headerBorder"
        >
            <component :is="slots?.['header-' + column.key]" v-bind="{ ...column }" />
        </HeaderCell>
    </div>
    <div
        v-if="!fixedColumns.hasTools && fixedColumns.right.length"
        :class="['pt-table-header_fixed', 'pt-table-header_fixed-right', { ['reach-border']: scrollInfo.scrollLeft === scrollInfo.maxScrollLeft } ]"
        :style="{ transform: `translate3d(-${scrollInfo.maxScrollLeft - scrollInfo.scrollLeft}px, 0, 0)`}"
    >
        <HeaderCell
            v-for="column in fixedColumns.right"
            :key="'fixed' + column.key"
            :column="column"
            :columnWidth="columnsWidth[column.key]"
            :setHeaderWidth="setHeaderWidth"
            :currentSorter="currentSorter"
            :changeCurrentSorter="changeCurrentSorter"
            :isFixedHeader="true"
            :isInPageMode="isInPageMode"
            :headerBorder="headerBorder"
        >
            <component :is="slots?.['header-' + column.key]" v-bind="{ ...column }" />
        </HeaderCell>
    </div>
</template>

<script lang="ts">
export default {
    name: 'TableHeader'
}
</script>

<script lang="ts" setup>
import { inject } from 'vue';
import type { Props as TableProps, SetHeaderWidth, ChangeCurrentSorter, CurrentSorter } from '../table.vue';
import HeaderCell from './headerCell.vue';
import type { ScrollInfo } from '../../../scrollbar/src/scrollbar.vue';

interface Props {
    columns: TableProps['columns'];
    columnsWidth: Record<string, string>;
    setHeaderWidth: SetHeaderWidth;
    currentSorter?: CurrentSorter;
    changeCurrentSorter: ChangeCurrentSorter;
    scrollInfo: ScrollInfo;
    fixedColumns: { left: TableProps['columns']; right: TableProps['columns']; hasTools: boolean; };
    isInPageMode: boolean;
    headerBorder: boolean;
}
defineProps<Props>();
const slots = inject<Record<string, any>>('slots');
</script>

<style lang="scss">
.pt-table-header-fixedWrapper {
    border-bottom: 1px solid #dfe1e6;
}

.pt-table-header-fixedWrapper2 {
    border: 1px solid #dfe1e6;
    border-bottom: none;
    box-sizing: content-box;
}

.pt-table-header {
    position: relative;
    display: flex;
    border-bottom: 1px solid #dfe1e6;
    font-size: 13px;
    color: #5e6c84;
    z-index: 10;
}
.pt-table-header_fixed {
    position: absolute;
    height: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
}

.pt-table-header_fixed-left {
    left: 0;
    border-right: 1px solid #dfe1e6;
    &.reach-border {
        border: none;
    }
}

.pt-table-header_fixed-right {
    right: 0;
    border-left: 1px solid #dfe1e6;
    &.reach-border {
        border: none;
    }
}
</style>
